<section class="header__title__with__buttom">
  <div class="header__text">
    <p class="title" [innerHTML]="title"></p>
    <p class="subtitle">{{subtitle}}</p>
  </div>
  <div class="header__button">
    <button *ngIf="action == 'modal' && this.actions.includes('post')" mat-button class="button" (click)="actionButtonModal()" >
      <img src="../../../assets/icons/icon-add-filled.svg">
      <span>{{nameButtom}}</span>
    </button>
    <button *ngIf="action == 'redirecionar' && this.actions.includes('post')" mat-button class="button" (click)="goToPage()" >
      <img src="../../../assets/icons/icon-add-filled.svg">
      <span>{{nameButtom}}</span>
    </button>
    <button *ngIf="action == 'upload'" mat-button class="button" (click)="csvInput.click()" >
      <input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="actionButton($event)" accept=".xls,.xlsx"/>
      <span>{{nameButtom}}</span>
    </button>
  </div>
</section>